export {
  AlertBeaconComponent,
  ALERT_BEACON_POPOVER_KEY,
  type AlertBeaconToggle,
} from './alert-beacon.component';
